import { Button, Modal } from 'react-bootstrap';

/**
 * SessionEndedModal — shown when an acting session ends on its own rather than by the user's choice:
 * its 60-minute lifetime ran out, or the API answered 401. The parked human has already been
 * restored by the time this renders; acknowledging reloads the route, so nothing half-rendered as
 * the account is ever left on screen. backdrop="static" and no close button, because there is
 * nothing to dismiss it to.
 */
export default function SessionEndedModal({ notice, onAcknowledge }) {
  if ( !notice ) {
    return null;
  }

  return (
    <Modal show={true} backdrop="static" size="lg">
      <Modal.Header>
        <Modal.Title>Session Ended</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {notice.endedName
          ? <>Your session as <strong>{notice.endedName}</strong> has ended.</>
          : <>Your session has ended.</>
        }
        {notice.restoredName &&
          <> You are signed in as <strong>{notice.restoredName}</strong> again.</>
        }
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={onAcknowledge}>Continue</Button>
      </Modal.Footer>
    </Modal>
  );
}
